import * as React from 'react';
import * as _ from 'lodash-es';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LayoutDashboard from 'components/Layout/Dashboard';
import Loader from 'components/Loader/Loader';
import Travelers from 'components/BookingDetails/Travelers';
import FlightDetails from 'components/BookingDetails/Flight/FlightDetails';
import AdditionalFlightDetails from 'components/BookingDetails/AdditionalFlightDetails';
import Notes from 'components/Notes/Notes';
import PaymentInfo from 'components/BookingDetails/Payment/PaymentInfo';
import Segments from 'components/BookingDetails/Flight/Segments';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/Breadcrumbs/Breadcrumb';
import SendEmailConfirmationPopup from 'components/Popup/SendEmailConfirmationPopup';
import NewPaymentPopup from 'components/Popup/NewPaymentPopup';
import HotelDetails from 'components/BookingDetails/Hotel/HotelDetails';
import HotelBookingDetails from 'components/BookingDetails/Hotel/HotelBookingDetails';
import Transactions from 'components/BookingDetails/Transactions/Transactions';
import AdditionalBookingDetails from 'components/BookingDetails/AdditionalBookingDetails';
import EditCustomCategoriesBookingPopup from 'components/Popup/EditCustomCategoriesBookingPopup';
import ConfirmationPopup from 'components/Popup/Confirmation';
import CRCRefundConfirmation from 'components/Popup/CRCRefundConfirmation';
import ModifyBookingsDetailsPopup from 'components/Popup/ModifyBookingsDetailsPopup';
import CarDetails from 'components/BookingDetails/Car/CarDetails';
import CarBookingDetails from 'components/BookingDetails/Car/CarBookingDetails';
import BookingSyncError from 'components/BookingDetails/SyncError/BookingSyncError';
import { get as getCreditCards } from 'actions/User/GetUserCreditCards';
import { hasPermission } from '../../helpers/Permission';
import cx from 'classnames';
import {} from 'react-router-dom';
import { sendEmail } from 'actions/Bookings/SendEmail';
import { enqueueSnackbarCustomMessage } from 'actions/Snackbar/resetSnackbar';
import { putCustomFieldResponses } from 'actions/Bookings/PutCustomFieldResponse';
import { getCustomFields } from 'actions/CustomFields/Get';
import {
  emptyCancelResults,
  cancelFlightBooking,
} from 'actions/Bookings/CancelBooking';
import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { ReduxState } from 'reducers/types';
import { getSingle as getBooking } from 'actions/Bookings/GetSingle';
import { getProviderDisplayName } from '../../helpers/getProviderDisplayName';
import { syncDuffelBooking } from 'actions/Bookings/SyncDuffelBooking';
import { getFeatures } from 'actions/Features/Get';
import isFeatureEnabled, { ScopeType } from '../../helpers/isFeatureEnabled';
const styles = require('./styles.pcss');
import { refund } from 'actions/Bookings/RefundBooking';
import { refundCRCPoints } from 'actions/Bookings/RefundCRCPoints';
import AddEditFlightCredit from 'components/Popup/AddFlightCreditPopup';
import RedeemCRCPointsPopup from 'components/BookingDetails/Flight/RedeemCRCPointsPopup';
import { updateBooking } from 'actions/Bookings/UpdateBooking';
import {
  PostFlightCreditParams,
  postBookingFlightCredit,
} from 'actions/FlightCredits/PostFlightCredit';

type Props = any;

export type Params = {
  bookingId: string;
};

type State = {
  openConfirmation: boolean;
  openNewPaymentPopup: boolean;
  openModifyDetails: boolean;
  id: string;
  additionalEmails: any;
  selectedPNR: string;
  userEmail: string;
  activeTabIndex: number;
  openCategories: boolean;
  openFlightCancelConfirmation: boolean;
  openFlightCreditPopup: boolean;
  openCRCRedeemPopup: boolean;
  isLoadingCRCRedeem: boolean;
  curFraudRule: string;
  bookingTravelers: any[];
  openCRCRefundConfirmation: boolean;
  crcRefundInProgress: boolean;
  crcRefundAmount: string;
  crcRefundError: string;
  crcRefundReason: string;
};

import {
  get as getTravelers,
  emptyResults as emptyTravelers,
  Params as GetTravelerParams,
} from 'actions/Travelers/Get';
import { PermissionTypes } from '../../constants';
import { Button } from '@mui/material';
import { redeemCRCPoints } from 'actions/Bookings/RedeemCRCPoints';

class BookingDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      openConfirmation: false,
      id: '',
      additionalEmails: '',
      selectedPNR: '',
      userEmail: '',
      activeTabIndex: 0,
      openNewPaymentPopup: false,
      openCategories: false,
      openFlightCancelConfirmation: false,
      openModifyDetails: false,
      curFraudRule: '',
      openFlightCreditPopup: false,
      openCRCRedeemPopup: false,
      isLoadingCRCRedeem: false,
      bookingTravelers: [],
      openCRCRefundConfirmation: false,
      crcRefundInProgress: false,
      crcRefundAmount: '',
      crcRefundError: '',
      crcRefundReason: 'Canceled booking',
    };
  }

  bookingId = this.props.params?.bookingId;

  navigate = (path: string) => {
    this.props.navigate(path);
  };
  componentDidMount() {
    this.props.getFeatures({});
    this.props.getBooking(this.props.params?.bookingId, this.props.navigate);
  }

  _getTravelersEmails = () => {
    const travelers = this.state.bookingTravelers || [];
    return travelers.map((traveler: any) => traveler.email);
  };

  get crcAlreadyRedeemed () {

    return this.props.booking?.booking?.transactions.some(({amountType, purpose}: {amountType: string, purpose: string}) => {
      return amountType === 'points' && purpose === 'purchase' ;
    }, 0);
  }

  componentWillReceiveProps = (nextProps: Props) => {
    if (
      this.props.booking.isLoading === true &&
      nextProps.booking.isLoading !== true
    ) {
      this.closeCategoriesPopup();
      const getTravelerParams: GetTravelerParams = {
        userId: _.get(nextProps.booking, 'booking.userId', ''),
      };
      this.props.getTravelers(getTravelerParams);
      this.props.getCreditCards(_.get(nextProps.booking, 'booking.userId', ''));
      const orgId = _.get(nextProps.booking, 'booking.organizationId', '');
      if (orgId) {
        this.props.getCustomFields(orgId);
      }
      this.setState({
        bookingTravelers: nextProps.booking?.booking?.travelers
          ?? (nextProps.booking?.booking?.traveler ? [nextProps.booking.booking.traveler] : []),
      });

    }

    if (
      this.props.cancelBookingState.success !== true &&
      nextProps.cancelBookingState.success === true
    ) {
      const booking = _.get(nextProps, 'booking.booking', {});
      if (this.isEligibleForCRCRefund(booking)) {
        this.setState({
          openCRCRefundConfirmation: true,
          crcRefundAmount: String(this.getCRCRefundPoints(booking) || ''),
          crcRefundError: '',
          crcRefundReason: 'Canceled booking',
        });
      }
    }

    if (nextProps.cancelBookingState.success !== null) {
      this.props.emptyCancelResults();
    }
  };

  getCRCRefundPoints = (booking: any) => {
    const transactions = _.get(booking, 'transactions', []);
    const points = transactions
      .filter((t: any) => t?.type === 'crPointDeduction' || t?.type === 'crPointWithdrawal')
      .reduce((sum: number, t: any) => sum + Math.abs(_.get(t, 'amount', 0)), 0);

    return points;
  };

  hasCRCRefundAlready = (booking: any) => {
    const transactions = _.get(booking, 'transactions', []);

    return transactions.some((transaction: any) => {
      const type = _.toLower(_.get(transaction, 'type', ''));
      const purpose = _.toLower(_.get(transaction, 'purpose', ''));

      return type === 'crpointdeposit' && purpose === 'refund';
    });
  };

  isCommercialRewardsFeatureEnabled = (booking: any) => {
    const agencyId = _.get(booking, 'organization.agencyId', '');
    const features = _.get(this.props, 'features.features', []);
    const featureStateLoaded = _.get(this.props, 'features.success', null) === true;

    if (!agencyId || !featureStateLoaded) {
      return true;
    }

    const featureFlag = features.find(
      (feature: any) => feature.name === 'commercialRewards',
    );

    if (!featureFlag) {
      return false;
    }

    return isFeatureEnabled(featureFlag, ScopeType.AGENCY, agencyId);
  };

  isEligibleForCRCRefund = (booking: any) => {
    return false;

  // If CRC points were redeemed for the booking, org has points enabled
  const hasCRCDeduction = this.getCRCRefundPoints(booking) > 0;
  if (!hasCRCDeduction) {
    return false;
  }

  const type = _.toLower(_.get(booking, 'type', ''));
  const rateType = _.toLower(_.get(booking, 'rateType', ''));
  const isFlight = type === 'flight';
  const isPrepaidHotel =
    type === 'hotel' &&
    (rateType.includes('prepay') || rateType.includes('prepaid'));

  if (!isFlight && !isPrepaidHotel) {
    return false;
  }

  return this.isCommercialRewardsFeatureEnabled(booking);
};

  shouldShowCRCRefundButton = (booking: any) => {
    const status = _.toLower(_.get(booking, 'status', ''));
    if (status !== 'canceled') return false;
    if (this.hasCRCRefundAlready(booking)) return false;
    return this.isEligibleForCRCRefund(booking);
  };

  openCRCRefundConfirmation = () => {
    const booking = _.get(this.props.booking, 'booking', {});

    this.setState({
      openCRCRefundConfirmation: true,
      crcRefundAmount: String(this.getCRCRefundPoints(booking) || ''),
      crcRefundError: '',
      crcRefundReason: this.state.crcRefundReason || 'Canceled booking',
    });
  };

  closeCRCRefundConfirmation = () => {
    this.setState({
      openCRCRefundConfirmation: false,
      crcRefundError: '',
      crcRefundAmount: '',
      crcRefundReason: 'Canceled booking',
    });
  };

  onChangeCRCRefundAmount = (event: any) => {
    const rawValue = event?.target?.value ?? '';
    const value = String(rawValue).trim();

    // Points are stored in raw integer units.
    if (!/^\d*$/.test(value)) {
      return;
    }

    this.setState({
      crcRefundAmount: value,
      crcRefundError: '',
    });
  };


  onClearCRCRefundAmount = () => {
    this.setState({
      crcRefundAmount: '',
      crcRefundError: '',
    });
  };

  onChangeCRCRefundReason = (event: any) => {
    this.setState({
      crcRefundReason: String(event?.target?.value ?? ''),
      crcRefundError: '',
    });
  };

  onSubmitCRCRefund = () => {
    const booking = _.get(this.props.booking, 'booking', {});
    const organizationId = _.get(booking, 'organizationId', '');
    const bookingId = _.get(booking, 'id', '');
    const pnr = _.get(booking, 'pnr', '');
    const amountValue = this.state.crcRefundAmount.trim();
    const reason = this.state.crcRefundReason.trim();

    // If agent does not provide a value, no adjustment should be made.
    if (amountValue === '') {
      this.closeCRCRefundConfirmation();
      return;
    }

    const points = Number(amountValue);

    if (!Number.isFinite(points) || points <= 0) {
      this.setState({ crcRefundError: 'Enter a valid points amount' });
      return;
    }

    const redeemedPoints = this.getCRCRefundPoints(booking);
    if (Math.abs(points - redeemedPoints) > 0.000001) {
      this.setState({ crcRefundError: `Points must match the redeemed amount (${redeemedPoints})` });
      return;
    }

    if (reason === '') {
      this.setState({ crcRefundError: 'Enter a refund reason' });
      return;
    }

    if (!organizationId || !bookingId) {
      this.closeCRCRefundConfirmation();
      return;
    }

    this.setState({
      crcRefundInProgress: true,
      crcRefundError: '',
    });

    this.props.refundCRCPoints({
      organizationId,
      bookingId,
      pnr,
      points,
      reason,
      onSuccess: () => {
        this.setState({
          openCRCRefundConfirmation: false,
          crcRefundInProgress: false,
          crcRefundAmount: '',
          crcRefundError: '',
          crcRefundReason: 'Canceled booking',
        });
        this.props.getBooking(this.props.params?.bookingId, this.props.navigate);
      },
      onError: (message: string) => {
        // Keep modal open so agent can fix amount after an error.
        this.setState({
          crcRefundInProgress: false,
          crcRefundError: message || 'Failed to refund CRC points',
        });
      },
    });
  };

  closeConfirmation = () => {
    this.setState({
      openConfirmation: false,
      id: '',
      selectedPNR: '',
      userEmail: '',
    });
  };

  closeModify = () => {
    this.setState({
      openModifyDetails: false,
      id: '',
      userEmail: '',
    });
  };

  handleUpdateBooking = (data: any) => {
    const { onSuccess: callerOnSuccess, ...rest } = data;
    this.props.updateBooking({
      ...rest,
      onSuccess: () => {
        callerOnSuccess?.();
        this.props.getBooking(this.props.params?.bookingId, this.props.navigate);
      },
    });
  };

  onCancelNewPaymentPopup = () => {
    this.setState({
      openNewPaymentPopup: false,
    });
  };

  onOpenNewPaymentPopup = () => {
    let pnr = _.get(this.props.booking, 'booking.pnr', '');
    const flightCreditDbRecordExists = _.get(
      this.props.booking,
      'booking.flightCreditRecord.ticketNumber',
      '',
    );
    const flightCreditNumber = _.get(
      this.props.booking,
      'booking.flight.appliedFlightCreditNumber',
      '',
    );
    const hasAttemptedToAddFlightCredit = _.get(
      this.props.booking,
      'attemptedFlightCreditAdd',
      '',
    );
    if (
      !flightCreditDbRecordExists &&
      flightCreditNumber &&
      !hasAttemptedToAddFlightCredit
    ) {
      this.setState({ openFlightCreditPopup: true });
    } else {
      this.setState({
        openNewPaymentPopup: true,
        selectedPNR: pnr,
      });
    }
  };

  onSubmitRefundPopup = (id: string, amount: number) => {
    const relatedTransaction: any = _.find(
      _.get(this.props.booking, 'booking.transactions', []),
      (t) => t.id == id,
    );
    this.props.refund(
      id,
      _.get(this.props.booking, 'booking.type', ''),
      _.get(relatedTransaction, 'type', '') == 'brexPoints'
        ? 'brex points'
        : 'credit card',
      amount,
    );
  };

  closeCategoriesPopup = () => {
    this.setState({
      openCategories: false,
    });
  };

  open = () => {
    this.setState({
      openCategories: true,
    });
  };

  onCLickEditTags = (event: any) => {
    this.setState({
      openCategories: true,
    });
  };

  isFlightRefundable = () => {
    const booking = _.get(this.props, 'booking.booking', {});

    if (typeof booking.refundable === 'boolean') {
      return booking.refundable;
    }

    const allSegments = [
      ...(booking.segments || []),
      ...(booking.flights || []).flatMap((f: any) => f?.segments ?? []),
    ];
    const flags = allSegments
      .map((s: any) => s?.refundable)
      .filter((v: unknown): v is boolean => typeof v === 'boolean');

    if (flags.length) {
      return flags.every(Boolean);
    }

    const penalty = _.get(booking, 'penalties.cancellation.exact.amount');
    return typeof penalty === 'number' ? penalty === 0 : false;
  };

  closeFlightCancelConfirmation = () => {
    this.setState({
      openFlightCancelConfirmation: false,
    });
  };

  onSubmitSend = (additionEmails: any) => {
    if (this.state.additionalEmails !== '') {
      additionEmails = `${this.state.additionalEmails}, ${additionEmails}`;
    }

    this.setState({
      openConfirmation: false,
      id: '',
      selectedPNR: '',
      additionalEmails: additionEmails,
      userEmail: '',
    });
  };

  onClickEmailSend = (event: any) => {
    let id = _.get(this.props.booking, 'booking.id', '');
    let pnr = _.get(this.props.booking, 'booking.pnr', '');
    let additionalEmails = _.get(
      this.props.booking,
      'booking.additionalEmails',
      null,
    );
    let userEmail = _.get(this.props.booking, 'booking.user.email', '');

    this.setState({
      id: id,
      selectedPNR: pnr,
      openConfirmation: true,
      userEmail: userEmail,
    });
  };

  onClickModify = (event: any) => {
    let id = _.get(this.props.booking, 'booking.id', '');
    let pnr = _.get(this.props.booking, 'booking.pnr', '');
    let userEmail = _.get(this.props.booking, 'booking.user.email', '');

    this.setState({
      id: id,
      openModifyDetails: true,
      userEmail: userEmail,
    });
  };

  onClickCancelFlightButton = (event: any) => {
    this.setState({
      openFlightCancelConfirmation: true,
    });
  };

  handleViewPolicy = (event: any) => {
    this.navigate(
      `/users/${_.get(
        this.props.booking,
        'booking.userId',
        '',
      )}?activeTab=travel-policy`,
    );
  };

  onSubmitFlightCancel = () => {
    this.props.cancelFlightBooking({ bookingId: this.bookingId });
    this.closeFlightCancelConfirmation();
  };

  onTabChange = (e: any, idx: number) => {
    this.setState({
      activeTabIndex: idx,
    });
  };

  onSyncDuffel = () => {
    this.props.syncDuffelBooking(
      _.get(this.props.booking, 'booking.userId', ''),
      _.get(this.props.booking, 'booking.orderId', ''),
    );
  };

  closeFlightCreditPopup = () => {
    this.setState({ openFlightCreditPopup: false });
  };

  submitBookingFlightCredit = (params: PostFlightCreditParams) => {
    this.props.postBookingFlightCredit(params);
    this.onOpenNewPaymentPopup();
  };

  getProvider = (type: string) => {
    switch (type) {
      case 'flight':
        const segments = _.get(this.props.booking, 'booking.segments', []);
        return segments?.[0]?.segment?.[0]?._meta?.provider;
      case 'hotel':
        return _.get(
          this.props.booking,
          'booking.hotel.roomDetails.0._meta.provider',
          '',
        );
      case 'car':
        return _.get(this.props.details, '_meta.providerName', 'See dev team');
      default:
        return '';
    }
  };

  renderDetails = (type: string) => {
    if (type == 'flight') {
      const segments = _.get(this.props.booking, 'booking.segments', []);
      const provider =
        segments?.[0]?.segment?.[0]?._meta?.provider || 'Unknown';
      const providerCode = _.get(
        this.props.booking,
        'booking.providerCodes.uapiProviderCode',
        'Provider Code Unkown',
      );
      const providerName = getProviderDisplayName(provider, providerCode);

      // Prefer flat booking fields updated by the modify flow;
      // fall back to the original GDS reservation structure.
      let basePrice: any =
        _.get(this.props.booking, 'booking.basePrice') ??
        _.get(this.props.booking, 'booking.reservations.[0].priceInfo.BasePrice', '');
      let passengers = _.get(
        this.props.booking,
        'booking.passengers',
        [],
      ).length;
      let taxes: any =
        _.get(this.props.booking, 'booking.taxPrice') ??
        _.get(this.props.booking, 'booking.reservations.[0].priceInfo.Taxes', '');
      let totalPrice = _.get(this.props.booking, 'booking.totalPrice', '')
        ?? _.get(this.props.booking, 'booking.customerPrice', '');

      if (taxes) {
        if (typeof taxes === 'string') taxes = taxes.replace(/^USD/, '');
        taxes = parseFloat(taxes);
      }

      if (basePrice) {
        if (typeof basePrice === 'string') basePrice = basePrice.replace(/^USD/, '');
        basePrice = parseFloat(basePrice);
      }

      return (
        <FlightDetails
          basePrice={basePrice}
          providerName={providerName}
          refundable={this.isFlightRefundable()}
          taxes={taxes}
          taxesArray={_.get(
            this.props.booking,
            'booking.reservations[0].priceInfo.TaxesInfo',
            [],
          )}
          passenger={passengers}
          totalPrice={totalPrice}
        />
      );
    }

    if (type == 'hotel') {
      return (
        <HotelDetails details={_.get(this.props.booking, 'booking', '')} />
      );
    }
    return <CarDetails details={_.get(this.props.booking, 'booking', '')} />;
  };

  renderBookingsDetail = (type: string) => {
    if (type == 'flight') {
      return (
        <Segments
          seatAssignments={_.get(
            this.props.booking,
            'booking.seatAssignments',
            [],
          )}
          segments={this.props.booking?.booking?.segments || []}
          confirmationNumbers={_.get(
            this.props.booking,
            'booking.confirmationNumbers',
            [],
          )}
          locations={_.get(this.props.booking, 'booking.airportLocation', [])}
          passengers={_.get(this.props.booking, 'booking.passengers', [])}
        />
      );
    }

    if (type == 'hotel') {
      return (
        <HotelBookingDetails
          booking={_.get(this.props.booking, 'booking', '')}
        />
      );
    }

    return (
      <CarBookingDetails booking={_.get(this.props.booking, 'booking', '')} />
    );
  };

  renderCancelButton = (type: string, provider: string, status: string) => {
    if (status == 'canceled') {
      return null;
    }

    if (
      type == 'flight' &&
      _.get(this.props.booking, 'booking.customerPrice', 0)
    ) {
      return (
        <div
          className={styles.cancelButton}
          onClick={this.onClickCancelFlightButton}
        >
          Cancel
        </div>
      );
    }

    return null;
  };

  renderFraud = (isFraud: any) => {
    if (isFraud) {
      return <div className={cx(styles.fraud, styles.canceled)}>Fraud</div>;
    }
    return;
  };

  renderStatus = (status: any) => {
    let style = '';

    switch (status) {
      case 'Completed':
        style = cx(styles.buttonCompleted);
        break;
      case 'Canceled':
        style = cx(styles.buttonCompleted, styles.canceled);
        break;
      case 'Errored':
        style = cx(styles.buttonCompleted, styles.canceled);
        break;
      case 'Pending':
        style = cx(styles.buttonCompleted, styles.pending);
        break;
      default:
        return null;
    }

    return <div className={style}>{status}</div>;
  };

  updateBookingTravelers = (travelerIds: string[]) => {
    const newBookingTravelers = this.props.travelers?.travelers?.filter(
      (trav: any) => travelerIds.includes(trav.id),
    );
    this.setState({
      bookingTravelers: newBookingTravelers,
    });
    this.props.updateBooking({
      bookingId: this.props.booking?.booking?.id,
      travelerIds,
    });
  };

  renderLoader = () => {
    return (
      <div className={styles.loaderContainer}>
        <Loader visible={true} />
      </div>
    );
  };

  getEnrichedBookingFields = () => {
    const bookingFields = _.get(this.props.booking, 'booking.customFields', []);
    const orgFields: any[] = _.get(this.props.customFields, 'fields', []);
    return bookingFields.map((f: any) => {
      const def = orgFields.find((d: any) => d.id === f.id);
      return def ? { ...f, name: def.name, type: def.type, options: def.options, isRequired: def.isRequired } : f;
    });
  };

  getMergedCustomFields = () => {
    const bookingFields = _.get(this.props.booking, 'booking.customFields', []);
    const orgFields: any[] = _.get(this.props.customFields, 'fields', []);
    const bookingFieldsEnriched = bookingFields.map((f: any) => {
      const def = orgFields.find((d: any) => d.id === f.id);
      return def ? { ...f, name: def.name, type: def.type, options: def.options, isRequired: def.isRequired } : f;
    });
    const bookingFieldIds = new Set(bookingFields.map((f: any) => f.id));
    const missingRequired = orgFields
      .filter((d: any) => d.isRequired && !bookingFieldIds.has(d.id))
      .map((d: any) => ({ id: d.id, name: d.name, type: d.type, options: d.options, isRequired: d.isRequired, value: '' }));
    return [...bookingFieldsEnriched, ...missingRequired];
  };

  onSubmitCategories = (customFieldResponses: any) => {
    this.props.putCustomFieldResponses({
      customFieldResponses,
      bookingId: _.get(this.props.booking, 'booking.id', ''),
    });
  };

  renderBookingSyncError = () => {
    return (
      <BookingSyncError
        syncError={_.get(this.props.booking, 'booking.syncError', null)}
      />
    );
  };

  renderLoading = () => {
    if (
      _.get(this.props.cancelBookingState, 'isLoading', false) ||
      this.state.crcRefundInProgress
    ) {
      return (
        <div className={styles.loaderContainer}>
          <Loader visible={true} />
        </div>
      );
    }

    return null;
  };

  isCRCRedeemVisible = () => {
    return false;

    if (!hasPermission('creditCards', PermissionTypes.charge)) return false;
    const orgId = _.get(this.props.booking, 'booking.organizationId', '');
    const featureFlag = (this.props.features?.features || []).find(
      (flag: any) => flag.name === 'showCrPoints',
    );
    if (!featureFlag || !orgId) return false;
    const type = _.get(this.props.booking, 'booking.type', '');
    const rateType = _.get(this.props.booking, 'booking.rateType', '');
    if (type !== 'flight' && rateType !== 'prepay') {
      return false;
    }
    return true;
  };

  openCRCRedeemPopup = () => {
    this.setState({ openCRCRedeemPopup: true });
  };

  closeCRCRedeemPopup = () => {
    this.setState({ openCRCRedeemPopup: false });
  };

  onSubmitCRCRedeem = () => {
    this.setState({ isLoadingCRCRedeem: true });
    this.props.redeemCRCPoints(
      this.bookingId,
      (data: any) => {
        this.props.enqueueSnackbarCustomMessage(
          `${data.transaction.amount} points applied to ${_.get(this.props.booking, 'booking.pnr', '')}. New balance: ${data.remainingBalance}`,
          'success',
        );
        this.setState({ isLoadingCRCRedeem: false });
        this.closeCRCRedeemPopup();
      },
      () => {
        this.props.enqueueSnackbarCustomMessage(
          'Failed to redeem CRC points',
          'error',
        );
        this.setState({ isLoadingCRCRedeem: false });
        this.closeCRCRedeemPopup();
      },
    );
  };

  renderDuffelSync = (provider: string, type: string) => {
    if (provider === 'duffel' && type === 'flight') {
      return (
        <div
          className={styles.sendEmailButton}
          onClick={this.onSyncDuffel}
        >
          Sync Duffel
        </div>
      );
    }
    return;
  };

  render() {
    let breadcrumbName = _.get(this.props.booking, 'booking.pnr', '');
    let status = _.get(this.props.booking, 'booking.status', '');
    let isFraud = _.get(this.props.booking, 'booking.isFraud', '');

    status = status.charAt(0).toUpperCase() + status.slice(1);

    let type = _.get(this.props.booking, 'booking.type', '');
    const provider = this.getProvider(type);

    if (this.props.booking.isLoading || this.props.isLoadingDuffelSync) {
      return (
        <LayoutDashboard>
          <Loader
            visible={true}
            id={'bookingLoad'}
          />
        </LayoutDashboard>
      );
    }

    const propsAdditionalEmails =
      _.get(this.props.booking, 'booking.additionalEmails', '') === '' ||
      _.get(this.props.booking, 'booking.additionalEmails', '') === null ||
      _.get(this.props.booking, 'booking.additionalEmails', '') === undefined
        ? ''
        : this.props.booking.booking.additionalEmails;

    const additionEmails =
      propsAdditionalEmails !== '' && this.state.additionalEmails !== ''
        ? `${propsAdditionalEmails}, ${this.state.additionalEmails}`
        : `${propsAdditionalEmails}${this.state.additionalEmails}`;

    const customFieldResponses = this.getMergedCustomFields();
    const enrichedBookingFields = this.getEnrichedBookingFields();
    const isBrexPoints =
      _.get(this.props.booking, 'booking.alternativePaymentType', false) ==
      'brexPoints';
    const cardNumber = _.get(
      this.props.booking,
      'booking.paymentInfo.last4',
      '',
    );

    return (
      <LayoutDashboard>
        <div>
          <Breadcrumbs className={styles.breadcrumbs}>
            <Breadcrumb
              name="Lookup"
              arrow
            />
            <Breadcrumb name={breadcrumbName} />
          </Breadcrumbs>
        </div>

        <div className={styles.headerPnr}>
          <div className={styles.id}>
            <span id="bookingPNR">{breadcrumbName}</span>
            {this.renderStatus(status)}
            {this.renderFraud(isFraud)}
          </div>
          <div className={styles.buttonContainer}>
            {hasPermission('bookings', PermissionTypes.update) && (
              <div
                className={styles.sendEmailButton}
                onClick={this.onClickModify}
              >
                Modify
              </div>
            )}
            <div
              className={styles.sendEmailButton}
              onClick={this.onClickEmailSend}
            >
              Send Email
            </div>
            {this.renderCancelButton(
              type,
              provider,
              _.get(this.props.booking, 'booking.status', ''),
            )}

            {this.shouldShowCRCRefundButton(
              _.get(this.props.booking, 'booking', {}),
            ) && (
              <div
                className={styles.sendEmailButton}
                onClick={this.openCRCRefundConfirmation}
              >
                Refund CRC
              </div>
            )}

            {hasPermission('creditCards', PermissionTypes.charge) &&
              type !== 'car' && (
                <div
                  className={styles.sendEmailButton}
                  onClick={this.onOpenNewPaymentPopup}
                >
                  Add Charge
                </div>
              )}

            {this.renderDuffelSync(provider, type)}

            {this.isCRCRedeemVisible() && (
              <Button
                className={cx(styles.sendEmailButton, styles.crcRedeemButton)}
                onClick={this.openCRCRedeemPopup}
                disabled={this.crcAlreadyRedeemed}
              >
                {!this.crcAlreadyRedeemed
                  ? 'Redeem CRC Points'
                  : 'CRC Points Redeemed'}
              </Button>
            )}
          </div>
        </div>

        <div className={styles.loaderWrapper}>
          {type !== 'car' && (
            <Tabs
              className={styles.tabs}
              value={this.state.activeTabIndex}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.onTabChange}
            >
              <Tab
                className={styles.tab}
                label="Details"
              />
              <Tab
                className={styles.tab}
                label="Transactions"
              />
            </Tabs>
          )}
          {this.renderDetailsTab(customFieldResponses, enrichedBookingFields)}
          {this.renderTransactionsTab()}
        </div>

        <SendEmailConfirmationPopup
          open={this.state.openConfirmation}
          onClose={this.closeConfirmation}
          onSubmit={this.onSubmitSend}
          id={this.state.id}
          type={_.get(this.props.booking, 'booking.type', '')}
          identifier={this.state.selectedPNR}
          additionalEmails={additionEmails}
          userEmail={_.get(this.props.booking, 'booking.user.email', '')}
        />

        <ModifyBookingsDetailsPopup
          open={this.state.openModifyDetails}
          close={this.closeModify}
          updateBooking={this.handleUpdateBooking}
          id={this.state.id}
          confirmationNumber={_.get(
            this.props.booking,
            'booking.confirmationNumber',
            '',
          )}
          booking={this.props.booking.booking}
          status={_.get(this.props.booking, 'booking.status', '')}
          type={_.get(this.props.booking, 'booking.type', '')}
          identifier={this.state.selectedPNR}
          additionalEmails={additionEmails}
          userEmail={_.get(this.props.booking, 'booking.user.email', '')}
          notes={_.get(this.props.booking, 'booking.notes', '')}
          basePrice={
            _.get(this.props.booking, 'booking.type') === 'hotel'
              ? (_.get(this.props.booking, 'booking.hotel.priceDetails.base') ??
                 _.get(this.props.booking, 'booking.basePrice'))
              : (_.get(this.props.booking, 'booking.basePrice') ??
                 (parseFloat(
                   (_.get(this.props.booking, 'booking.car.priceDetails.days', 0) *
                     _.get(this.props.booking, 'booking.car.priceDetails.pricePerDay', 0)
                   ).toFixed(2)
                 ) || undefined))
          }
          totalPrice={
            _.get(this.props.booking, 'booking.totalPrice') ??
            _.get(this.props.booking, 'booking.car.priceDetails.estimatedTotalPrice')
          }
          requiredCharges={_.get(this.props.booking, 'booking.requiredCharges')}
          providerReturnDate={
            _.get(this.props.booking, 'booking.providerReturnDate') ??
            _.get(this.props.booking, 'booking.endDate')
          }
          taxesAndFees={_.get(this.props.booking, 'booking.hotel.priceDetails.taxes')}
          customerPrice={_.get(this.props.booking, 'booking.customerPrice')}
          resortFee={_.get(this.props.booking, 'booking.hotel.hotelFees.total')}
          departureDate={_.get(this.props.booking, 'booking.departureDate')}
        />

        <NewPaymentPopup
          open={this.state.openNewPaymentPopup}
          in_process={_.get(this.props.user, 'isLoading', false)}
          onCancel={this.onCancelNewPaymentPopup}
          listOfCreditCards={_.get(this.props.user, 'user.creditCards', [])}
          bookingId={_.get(this.props.booking, 'booking.id', '')}
          pnr={_.get(this.props.booking, 'booking.pnr', '')}
          type={_.get(this.props.booking, 'booking.type', '')}
          rateType={_.get(this.props.booking, 'booking.rateType', '')}
          userId={_.get(this.props.booking, 'booking.userId', '')}
          isFlightCreditApplied={
            !!_.get(this.props.booking, 'booking.isFlightCreditApplied', '')
          }
          organizationId={_.get(
            this.props.booking,
            'booking.organizationId',
            '',
          )}
          getCreditCards={this.props.getCreditCards}
          user={_.get(this.props.booking, 'booking.user', false)}
        />
        <AddEditFlightCredit
          open={this.state.openFlightCreditPopup}
          close={this.closeFlightCreditPopup}
          submit={this.submitBookingFlightCredit}
          bookingId={_.get(this.props.booking, 'booking.id', '')}
          title="The synced PNR shows a flight credit was used but we don't have it in our system. Please add the flight credit used for this booking before entering the transaction amount"
        />

        {this.props.isLoadingRefund && this.renderLoader()}
        {this.state.isLoadingCRCRedeem && this.renderLoader()}

        <EditCustomCategoriesBookingPopup
          open={this.state.openCategories}
          onCancel={this.closeCategoriesPopup}
          submit={this.onSubmitCategories}
          customFieldResponses={customFieldResponses}
          allCustomFields={this.props.customFields?.fields || []}
        />

        <RedeemCRCPointsPopup
          open={this.state.openCRCRedeemPopup}
          onClose={this.closeCRCRedeemPopup}
          onSubmit={this.onSubmitCRCRedeem}
          pnr={_.get(this.props.booking, 'booking.pnr', '')}
          bookingPrice={_.get(this.props.booking, 'booking.customerPrice', 0) ?? 0}
        />

        <ConfirmationPopup
          open={this.state.openFlightCancelConfirmation}
          onClose={this.closeFlightCancelConfirmation}
          onSubmit={this.onSubmitFlightCancel}
          title="Cancel Booking?"
          bodyText={`A refund of $${
            _.get(this.props.booking, 'booking.customerPrice', 0)
              ? _.get(this.props.booking, 'booking.customerPrice', 0).toFixed(2)
              : ' - - '
          } will be made to the credit card ending in ${cardNumber}`}
          submitButtonText="Continue"
          closeButtonText="Cancel"
          disableX={true}
        />

        <CRCRefundConfirmation
          open={this.state.openCRCRefundConfirmation}
          onClose={this.closeCRCRefundConfirmation}
          onSubmit={this.onSubmitCRCRefund}
          bookingNumber={_.get(this.props.booking, 'booking.pnr', '')}
          bookingValue={_.get(this.props.booking, 'booking.customerPrice', 0)}
          suggestedPoints={String(
            this.getCRCRefundPoints(_.get(this.props.booking, 'booking', {})) || '',
          )}
          onChangeAmount={this.onChangeCRCRefundAmount}
          errorMessage={this.state.crcRefundError}
          onClearAmount={this.onClearCRCRefundAmount}
          amount={this.state.crcRefundAmount}
          reason={this.state.crcRefundReason}
          onChangeReason={this.onChangeCRCRefundReason}
        />

        {this.renderLoading()}
      </LayoutDashboard>
    );
  }

  renderDetailsTab(customFieldResponses: any[], enrichedBookingFields: any[]) {
    if (this.state.activeTabIndex !== 0) {
      return null;
    }

    const type = _.get(this.props.booking, 'booking.type', '');
    let operatingAirline = _.get(
      this.props.booking,
      'booking.segments[0].operatingAirline',
      '-',
    );
    if (operatingAirline === '-') {
      operatingAirline = _.get(this.props.booking, 'booking.merchant', '-');
    }
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          {this.renderBookingsDetail(type)}

          <Travelers
            type={type}
            traveler={_.get(this.props.booking, 'booking.traveler[0]', '')}
            passengers={this.state.bookingTravelers}
            isLoading={_.get(this.props.booking, 'isLoading', true)}
            userTravelers={this.props.travelers?.travelers || []}
            updateBookingTravelers={this.updateBookingTravelers}
            bookingType={this.props.booking?.booking?.type}
            bookingId={this.props.booking?.booking?.id}
          />

          <AdditionalBookingDetails
            customFieldResponses={enrichedBookingFields}
            onCLickEdit={this.onCLickEditTags}
          />

          {type === 'flight' && (
            <AdditionalFlightDetails
              ticketNumber={_.get(
                this.props.booking,
                'booking.ticketNumbers[0]',
                '-',
              )}
              source={_.get(this.props.booking, 'booking.source', '-')}
              organizationId={_.get(
                this.props.booking,
                'booking.organizationId',
                '-',
              )}
              operatedBy={operatingAirline}
              clickViewPolicy={this.handleViewPolicy}
            />
          )}

          <Notes
            id={this.bookingId}
            entity={_.get(this.props.booking, 'booking')}
            type="booking"
          />
        </div>
        <div className={styles.sidebar}>
          {this.renderDetails(type)}
          {(!_.isEmpty(_.get(this.props.booking, 'booking.paymentInfo', {})) ||
            _.get(
              this.props.booking,
              'booking.alternativePaymentType',
              false,
            ) == 'brexPoints') &&
            type !== 'car' && (
              <PaymentInfo booking={_.get(this.props.booking, 'booking', {})} />
            )}
          {this.renderBookingSyncError()}
        </div>
      </div>
    );
  }

  renderTransactionsTab() {
    if (this.state.activeTabIndex !== 1) {
      return null;
    }

    const userCreditCards = _.get(this.props.user, 'user.creditCards', []);

    return (
      <Transactions
        transactions={_.get(this.props.booking, 'booking.transactions', [])}
        refundable={hasPermission('creditCards', PermissionTypes.refund)}
        onClickRefund={this.onSubmitRefundPopup}
        organization={_.get(this.props.booking, 'booking.organization', [])}
        bookingPnr={_.get(this.props.booking, 'booking.pnr', '')}
        travelersEmails={this._getTravelersEmails()}
      />
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    booking: state.booking,
    cancelBookingState: state.cancelBooking,
    user: state.user,
    travelers: state.travelers,
    isLoadingRefund: state.bookingRefund.isLoading,
    isLoadingDuffelSync: state.syncDuffelbooking.isLoading,
    customFields: state.customFields,
    features: state.features,
  };
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getBooking,
      getTravelers,
      sendEmail,
      putCustomFieldResponses,
      getCustomFields,
      getFeatures,
      updateBooking,
      syncDuffelBooking,
      emptyCancelResults,
      getCreditCards,
      refund,
      refundCRCPoints,
      cancelFlightBooking,
      postBookingFlightCredit,
      enqueueSnackbarCustomMessage,
      redeemCRCPoints,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(BookingDetails);
